var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertaAtencao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "rect-1",
    width: 50,
    height: 50,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    x: 0,
    y: 0,
    fill: "black"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "white",
    xlinkHref: "#rect-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-179.999936 25 25)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "none",
    xlinkHref: "#rect-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 22.5,
    y: 12.5,
    fill: "rgb(243,202,62)",
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 15,
    x: 22.5,
    y: 22.5,
    fill: "rgb(243,202,62)",
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(243,202,62)",
    fillRule: "evenodd",
    d: "M0 25C0 11.1928711 11.1928711 0 25 0s25 11.1928711 25 25-11.1928711 25-25 25S0 38.8071289 0 25zm5 0c0 11.04568481 8.95428467 20 20 20 11.03942871-.01513672 19.98486328-8.96057129 20-20 0-11.04568481-8.95428467-20-20-20S5 13.95431519 5 25z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertaAtencao);
export default __webpack_public_path__ + "static/media/alerta_atencao.11c3cbf1bd156efae3e0882980346ba2.svg";
export { ForwardRef as ReactComponent };